<template>
  <div :class="computedClass">
    <label
      :for="id ?? name"
      :aria-label="name"
    >
      <input
        :id="id ?? name"
        role="switch"
        aria-label="Controle de seleção"
        :name="name"
        type="checkbox"
        :disabled="disabled"
        v-bind="$attrs"
        @click="e => $emit('onClick', e)"
      />
      <span class="jade-switch__track"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'JadeSwitch',

  props: {
    disabled: Boolean,
    disabledFocus: Boolean,
    name: String,
    id: String
  },

  computed: {
    computedClass () {
      return {
        'jade-switch': true,
        'is-focus-disabled': this.disabledFocus
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/switch.css';
</style>
